// extracted by mini-css-extract-plugin
export default {"container":"ingredient-details-full-page_container__RIE1C"};